import * as angular from "angular";
import {Settelment} from "../models/settelment.model";

export class ContractsRequestsService {
  constructor(private $contracts, private ContractsAPI) {
  }


  createNewContract(contractName: string, settlementsArray: Settelment[], accountId?: string) {
    const api = this.ContractsAPI.actions.createContract;
    return this.$$call(api, {name: contractName, accountId: accountId}, settlementsArray, {});
  }

  updateOne(contractId: string, newName: string) {
    const api = this.ContractsAPI.actions.updateContract;
    return this.$$call(api, {}, {newContractName: newName}, {id: contractId});
  }

  deleteContract(contractId: string) {
    const api = this.ContractsAPI.actions.deleteContract;
    return this.$$call(api, {}, {}, {id: contractId});
  }

  assignAccounts(contractId: string, payload: { ids?: string[], excludedIds?: string[] }) {
    const api = this.ContractsAPI.actions.addAccounts;
    return this.$$call(api, {}, payload, {id: contractId});
  }

  removeAccounts(contractId: string, accountIds: string[]) {
    const api = this.ContractsAPI.actions.removeAccounts;
    return this.$$call(api, {}, accountIds, {id: contractId});
  }

  addNewProgramToContract(contractId: string, program: Settelment) {
    const api = this.ContractsAPI.actions.addNewProgramToContract;
    return this.$$call(api, {}, program, {id: contractId});
  }

  removeProgramFromContract(contractId: string, programType: string) {
    const api = this.ContractsAPI.actions.removeProgramFromContract;
    return this.$$call(api, {programType: programType}, {}, {id: contractId});
  }

  setAsDefault(contractId: string) {
    const api = this.ContractsAPI.actions.setAsDefault;
    return this.$$call(api, {}, {}, {id: contractId});
  }


  $$call(_apiCall, _params?, _data?, _options?, contractId?) {
    return this.$contracts(contractId).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.contracts')
  .service('contractsRequestsService', ContractsRequestsService);
